import ProductCard from '@components/Cards/ProductCard';
import { ButtonStyleEnum } from '@enums/button-enums';

const GridItem = ({ item, content, hideAddToCartButton, financingText, showFinancing }) => {
  const { saleText, newText, addToCartText, outOfStockText, shopLocalText } = content || {};

  return (
    <ProductCard
      product={item}
      saleText={saleText}
      newText={newText}
      addToCartText={addToCartText}
      outOfStockText={outOfStockText}
      shopLocalText={shopLocalText}
      buttonStyle={ButtonStyleEnum.Secondary}
      hideAddToCartButton={hideAddToCartButton}
      showFinancing={showFinancing}
      financingText={financingText}
      className="grid-item"
      listName="ProductGrid"
    />
  );
};

export default GridItem;
